import { render, staticRenderFns } from "./EditExerciseUnscrambleWord.vue?vue&type=template&id=50af025b&"
import script from "./EditExerciseUnscrambleWord.vue?vue&type=script&lang=ts&"
export * from "./EditExerciseUnscrambleWord.vue?vue&type=script&lang=ts&"
import style0 from "./EditExerciseUnscrambleWord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports